module.exports = __webpack_public_path__ + "static/media/t15.3bc913b8.jpg";